import React, { FC } from 'react';
import { SlideWrapper } from './Slide.style';

type SlideProps = {
  data: {
    id: number;
    img: string;
    text: string;
    name: string;
    position: string;
  };
};

const Slide: FC<SlideProps> = ({ data }) => {
  return (
    <SlideWrapper>
      <img className="slide-img" src={data.img} alt="" />
      <p className="slide-text">{data.text}</p>
      <div>
        <div className="slide-name">{data.name}</div>
        <div className="slide-position">{data.position}</div>
      </div>
    </SlideWrapper>
  );
};

export default Slide;
